import { Card, Modal, Rate } from "antd"
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import { setModalState } from "../../store/reducers/Modal/actions";
import { FaPencilAlt } from "@react-icons/all-files/fa/FaPencilAlt";
import { MdFileDownload } from "@react-icons/all-files/md/MdFileDownload";

import Button from "../../components/forms/Button";
import { FaLock } from '@react-icons/all-files/fa/FaLock';
import { useEffect, useState } from "react";
import { postRequest } from "../../services/requestService";
import downloadCoverLetterAsPDF from "../CoverLetterModal/service";
import { getLastResume } from "../../services/resumeService";
import TextArea from "antd/es/input/TextArea";
import { IoMdColorWand } from '@react-icons/all-files/io/IoMdColorWand';
import { refreshStats } from "../../store/reducers/Jobs/actions";
import { reportEvent } from "../../services/analyticsService";

export default props => {
    const { isImportJobModalOpen, modalParams } = useSelector(({ ModalReducer }) => ModalReducer);
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const [text, setText] = useState('')
    const [loading, setLoading] = useState();
    const dispatch = useDispatch()

    const onClose = () => {
        dispatch(setModalState('isImportJobModalOpen', false))
    }
    const onSubmit = async () => {
        reportEvent('import_job_modal', 'submit_start')
        if (!text) {
            reportEvent('import_job_modal', 'submit_start', { reason: 'missing_text' })
            return
        }
        setLoading(true)
        try {
            const res = await postRequest('application/create', { text })
            dispatch(refreshStats())
            setLoading(false)
            if (res.data.savedJob) {
                reportEvent('import_job_modal', 'submit_success')
                dispatch(setModalState('isImportJobModalOpen', false))
                dispatch(setModalState('isApplicationModalOpen', true, { savedJob: res.data.savedJob }))
            }
            else throw new Error("Invalid response from application/create")
        }
        catch(e) {
            console.error(e)
            setLoading(false)
            reportEvent('import_job_modal', 'submit_start', { reason: 'exception' })
        }
    }

    return (
        <Modal className="import-job-modal"
            onCancel={() => onClose()}
            open={isImportJobModalOpen} footer={null}>
            <div className="title">Import a new job!</div>

            <div className="content">
                <div className="subtitle">Paste the job description you'd like to tailor the application kit to</div>
                <TextArea placeholder="Place the job description here" value={text} onChange={e => setText(e.target.value.trim())} />
                <br />
                <Button onClick={onSubmit} disabled={!text} loading={loading}>
                    <IoMdColorWand />
                    Generate
                </Button>
            </div>

        </Modal>
    )
}